import { render, staticRenderFns } from "./PersonalPerfil.vue?vue&type=template&id=586dc09d"
import script from "./PersonalPerfil.vue?vue&type=script&lang=js"
export * from "./PersonalPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports